import ActivityFilter from "compid/pages/ActivityPage/classes/ActivityFilter";
import { DatePickerView } from "compid/ui/DatePicker";
import React, { useEffect, useState } from "react";
import { SVGAsset } from "res";
import { useFilterBarContext } from "../..";
import "./styles.css";

/**
 * @function FilterCustomDateRange
 * @param {STRING} className - Additional class name to add to the row
 * @param {STRING} value - The value that should be passed when the date has been updated
 * @returns {React.Component}
 * @exported true
 * @description Date range row to be shown in the filter bar
 * @example <FilterCustomDateRange value="custom">Custom date range</FilterCustomDateRange>
 */
export default function FilterCustomDateRange(props) {
    const { state, setCustomDateFilter } = useFilterBarContext();
    const defaultDates = ActivityFilter.getCustomDefaultDates();
    const [ dates, setDates ] = useState({...defaultDates});

    const className = props.className ?? "";
    // When the custom date row is selected update the state
    const rowClick = evt => setCustomDateFilter instanceof Function
        ? setCustomDateFilter({ value: dates, label: props.children })
        : undefined;
    // When a date picker has been updated then update the state
    const dateChange = prop => value => {
        if(setCustomDateFilter instanceof Function) {
            setCustomDateFilter({ value: { ...dates, [prop] : value }, label: props.children });
        }

        setDates({ ...dates, [prop] : value });
    };
    // If the state is updated and the custom property isn't set then reset the dates back to the default
    useEffect(() => state.custom === undefined ? setDates({...defaultDates}) : undefined, [ state ]);

    return (
        <>
            {   state.custom !== undefined &&  
                <>
                    <div className="custom-date-range-container flex-container flex-horizontal align-center flex-width">
                        <div className="flex-width toggle-column spacer-column"></div>
                        <div className="date-range-flex-item flex-container flex-vertical flex-width start-date">
                            <b className="custom-date-label">Start date:</b>
                            <DatePickerView disableWeekends={false} setDate={ dates.startDate } enablePast={ true } onChange={ dateChange("startDate") } />
                        </div>
                        <div className="set-width icon-container">
                            <SVGAsset id="RightArrowIcon" className="middle-arrow" />
                        </div>
                        <div className="date-range-flex-item flex-container flex-vertical flex-width end-date">
                            <b className="custom-date-label">End date:</b>
                            <DatePickerView disableWeekends={false} setDate={ dates.endDate } enablePast={ true } onChange={ dateChange("endDate") } />
                        </div>
                    </div>
                </>
             } 
        </>
    );
}